module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.d1b90a91.svg";